export default from './oneLine';
